import { useState } from "react";
import { useHistory } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { Container, Col, Card } from "react-bootstrap";
import { Row as RowAntd, Col as ColAntd, Modal, Grid } from "antd";

import { bannerSettings } from "lib/slick";
import { productLists } from "data/product";
import { categoryList } from "data/categories";

import Slider from "react-slick";
import Button from "antd-button-color";

import "./Home.css";
import Banner from "components/Home/Banner";
import CardProduct from "components/Card/Product";
import CardCategory from "components/Card/Category";

const banners = [
  "https://images.tokopedia.net/img/cache/1208/NsjrJu/2021/8/30/b1223896-9dd2-4bb1-9f32-0596e741547f.jpg.webp",
  "https://images.tokopedia.net/img/cache/1208/NsjrJu/2021/8/30/e450dd85-0f4b-4993-9f91-a9aa075bff21.jpg.webp",
];

const imagePrefix = "/assets/img/category";

const HomeContainer = () => {
  const history = useHistory();
  const screens = Grid.useBreakpoint();

  const [showCategory, setShowCategory] = useState(false);

  return (
    <>
      <Container>
        <section className="banner-section">
          <AnimatePresence>
            <Slider {...bannerSettings}>
              {banners.map((data) => (
                <Col key={data} className="px-0">
                  <Banner image={data} />
                </Col>
              ))}
            </Slider>
          </AnimatePresence>
        </section>
        <section>
          <RowAntd gutter={[10, 10]} className="mb-5">
            <ColAntd lg={6} md={12} sm={12} xs={12} className="border-end">
              <Card className="border-0">
                <Card.Body>
                  <Card.Title className="fs-15">Area bali</Card.Title>
                  <p className="text-muted mb-0 fs-13">
                    Kami melayani penyewaan dan pemasangan barang hanya di area bali saja
                  </p>
                </Card.Body>
              </Card>
            </ColAntd>
            <ColAntd lg={6} md={12} sm={12} xs={12} className={`${screens.lg ? "border-end" : ""}`}>
              <Card className="border-0">
                <Card.Body>
                  <Card.Title className="fs-15">Gratis ongkir</Card.Title>
                  <p className="text-muted mb-0 fs-13">
                    Khusus di daerah kedonganan dan sekitarnya kami memberikan bebas ongkir
                  </p>
                </Card.Body>
              </Card>
            </ColAntd>
            <ColAntd lg={6} md={12} sm={12} xs={12} className="border-end">
              <Card className="border-0">
                <Card.Body>
                  <Card.Title className="fs-15">DP aja dulu</Card.Title>
                  <p className="text-muted mb-0 fs-13">
                    Anda bisa melakukan pembayaran 10% diawal (uang tidak bisa dikembalikan jika
                    terjadi pembatalan)
                  </p>
                </Card.Body>
              </Card>
            </ColAntd>
            <ColAntd lg={6} md={12} sm={12} xs={12}>
              <Card className="border-0">
                <Card.Body>
                  <Card.Title className="fs-15">Pelanggan bahagia</Card.Title>
                  <p className="text-muted mb-0 fs-13">
                    Kami memberikan barang dan jasa terbaik untuk pelanggan kami yang spesial
                  </p>
                </Card.Body>
              </Card>
            </ColAntd>
          </RowAntd>
        </section>

        <section>
          <div className="mb-4">
            <div className="w-100 mb-4">
              <span className="fs-20-s mb-4 h4 mt-4">Kategori</span>
            </div>

            <AnimatePresence>
              <RowAntd gutter={[30, 30]}>
                {[...Array(7)].map((_, i) => (
                  <ColAntd xxl={3} xl={3} lg={3} md={6} sm={8} xs={8} key={categoryList[i].value}>
                    <CardCategory
                      label={categoryList[i].label}
                      image={`${imagePrefix}/${categoryList[i].image}`}
                    />
                  </ColAntd>
                ))}
                <ColAntd xxl={3} xl={3} lg={3} md={6} sm={8} xs={8}>
                  <CardCategory
                    label="Semua Kategori"
                    image={`${imagePrefix}/menu.png`}
                    onClick={() => setShowCategory(true)}
                  />
                </ColAntd>
              </RowAntd>
            </AnimatePresence>
          </div>
          <div className="mb-5">
            <div className="w-100 mb-2 d-flex justify-content-between align-items-end">
              <span className="fs-20-s h4 mt-2">Cocok untuk anda</span>
              <Button
                type="link"
                className="text-muted float-end px-0"
                onClick={() => history.push("/products")}
              >
                <u>Lainnya</u>
              </Button>
            </div>

            <AnimatePresence>
              <RowAntd gutter={[14, 14]}>
                {productLists.map((product) => (
                  <ColAntd xxl={4} xl={4} lg={6} md={6} sm={8} xs={12} key={product.name}>
                    <CardProduct product={product} />
                  </ColAntd>
                ))}
              </RowAntd>
            </AnimatePresence>
          </div>

          <div className="mb-5">
            <div className="w-100 mb-2 d-flex justify-content-between align-items-end">
              <span className="fs-20-s h4 mt-2">Paling banyak dilihat</span>
              <Button
                type="link"
                className="text-muted float-end px-0"
                onClick={() => history.push("/products")}
              >
                <u>Lainnya</u>
              </Button>
            </div>

            <AnimatePresence>
              <RowAntd gutter={[14, 14]}>
                {productLists.reverse().map((product) => (
                  <ColAntd xxl={4} xl={4} lg={6} md={6} sm={8} xs={12} key={product.name}>
                    <CardProduct product={product} />
                  </ColAntd>
                ))}
              </RowAntd>
            </AnimatePresence>
          </div>

          <div className="text-center my-5">
            <Button ghost type="dark" className="mx-auto" onClick={() => history.push("/products")}>
              Semua Katalog
            </Button>
          </div>
        </section>
      </Container>

      <Modal
        centered
        footer={null}
        width={800}
        zIndex="1030"
        title={<span className="text-center w-100 d-block fw-500">Semua Kategori</span>}
        visible={showCategory}
        onOk={() => setShowCategory(false)}
        onCancel={() => setShowCategory(false)}
        closeIcon={<i className="far fa-times" />}
      >
        <AnimatePresence>
          <RowAntd gutter={[20, 40]}>
            {categoryList.map((data) => (
              <ColAntd xxl={6} xl={6} lg={6} md={8} sm={8} xs={8} key={data.value}>
                <CardCategory
                  key={data.value}
                  label={data.label}
                  image={`${imagePrefix}/${data.image}`}
                />
              </ColAntd>
            ))}
          </RowAntd>
        </AnimatePresence>
      </Modal>
    </>
  );
};

export default HomeContainer;
